import { map, forEach, find } from 'lodash'
import next from 'immer'
import { getProficiencyBand } from '../../../../common/util'
import { compareByStudentName } from '../../../../../Gradebook/transformers'

export const augmentWithBand = (metricInfo = [], bandInfo = []) =>
  map(metricInfo, (metric) => {
    return next(metric, (draftMetric) => {
      forEach(draftMetric.tests, (test, testId) => {
        draftMetric.tests[testId].proficiencyBand = getProficiencyBand(
          test.score,
          bandInfo
        )
      })
    })
  })

export const augmentWithStudentInfo = (metricInfo = [], orgData = []) => {
  const data = map(metricInfo, (student) => {
    // get the related organisation
    const relatedOrg =
      find(orgData, (org) => org.groupId === student.groupId) || {}
    const { groupName = '-', schoolName = '-', teacherName = '-' } = relatedOrg
    return { ...student, groupName, schoolName, teacherName }
  })

  // Sort by lastName → firstName → middleName (not formatted display string)
  return data.sort(compareByStudentName)
}
